﻿
import config from "../config"
const baseUrl = config.base_url + "lz_sample/"
export default {
    simpleList: {
        url:  baseUrl + "list",
        type: "get",
    },
    page: {
        url:  baseUrl + "admin/page/{farmId}",
        type: "get",
    },
    remove:{
        url:  baseUrl + "delete",
        type: "get",
    },
    save:{
        url:  baseUrl + "save",
        type: "post",
    },
    sync: {
        url:  baseUrl + "sync/{farmId}",
        type: "get",
    },
}

